import { render, staticRenderFns } from "./designerReview.vue?vue&type=template&id=6f5a7d46&scoped=true&"
import script from "./designerReview.vue?vue&type=script&lang=js&"
export * from "./designerReview.vue?vue&type=script&lang=js&"
import style0 from "./designerReview.vue?vue&type=style&index=0&lang=css&"
import style1 from "./designerReview.vue?vue&type=style&index=1&id=6f5a7d46&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a7d46",
  null
  
)

export default component.exports